import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { UpgradePipeModule } from '../../filters/upgrade-pipe.module';
import { ComponentsModule } from '../../components/components.module';
import { TranslateModule } from '../../modules/translate.module';

import { FormDomainComponent } from './form-domain.component';
import { FormDomainDetailComponent } from './steps/detail/form-domain-detail.component';
import { FormDomainScanComponent } from './steps/scan/form-domain-scan.component';
import { FormDomainFeaturesComponent } from './steps/features/form-domain-features.component';
import { FormDomainGroupsComponent } from './steps/domain_groups/form-domain-groups.component';
import { FormDomainUsersComponent } from './steps/users/form-domain-users.component';

// Login type sub-components
import { FormDomainScanLoginFormComponent } from './steps/scan/login-types/form/form-domain-scan-login-form.component';
import { FormDomainScanLoginCustomMultistepComponent } from './steps/scan/login-types/custom-multistep/form-domain-scan-login-custom-multistep.component';
import { FormDomainScanInternalUrlsComponent } from './steps/scan/internal-urls/form-domain-scan-internal-urls.component';
import {
    FormBuilderDynamicAcModule,
    FormBuilderDynamicModule, FormBuilderSelectAcModule,
    FormBuilderSelectModule, FormBuilderValidationModule,
    IconsModule,
    LayoutModule, MonEventTriggerModule, MonSelectAllCheckboxModule,
    MonSwitchModule,
} from '@monsido/angular-shared-components';
import { NgbPagination, NgbTimepicker } from '@ng-bootstrap/ng-bootstrap';
import { FormDomainScanLoginOffice365Component } from './steps/scan/login-types/office365/form-domain-scan-login-office365.component';
import { FormDomainScanLoginBasicAuthComponent } from './steps/scan/login-types/basic-auth/form-domain-scan-login-basic-auth.component';
import { MonActionMenuModule } from '@client/ng2/shared/components/action-menu/action-menu.module';
import { ModalsDirectivesModule } from '@client/app/modules/modals/directives/modals-directives.module';
import { FormDomainGroupsCreateComponent } from '@client/app/forms/domain/steps/domain_groups/create/create.component';
import {
    FormDomainGroupsUsersComponent,
} from '@client/app/forms/domain/steps/domain_groups/steps/users/users.component';
import {
    FormDomainGroupsMatchRuleComponent,
} from '@client/app/forms/domain/steps/domain_groups/steps/rules/match-rule/match-rule.component';
import {
    FormDomainGroupsRulesComponent,
} from '@client/app/forms/domain/steps/domain_groups/steps/rules/rules.component';
import { FormRulesImportSetupComponent } from '@client/app/forms/domain/steps/domain_groups/steps/rules/import/setup/form-rules-import-setup.component';
import { FormRuleImportUploadComponent } from './steps/domain_groups/steps/rules/import/upload/form-rule-import-upload.component';
import { FormImportGroupRulesComponent } from './steps/domain_groups/steps/rules/import/form-import-group-rules.component';
import { FormDomainGroupsEditComponent } from './steps/domain_groups/edit/form-domain-groups-edit.component';
import { UpgradeFormsModule } from '@client/app/forms/forms.module';
import { FormDomainDetailCmsComponent } from '@client/app/forms/domain/steps/detail/form-domain-detail-cms.component';
import { NgbTooltipMfeModule } from '@client/mfe/overlay/ngb-tooltip-mfe.module';

@NgModule({
    imports: [
        FormsModule,
        CommonModule,
        UpgradeFormsModule,
        UpgradePipeModule,
        ComponentsModule,
        TranslateModule,
        FormBuilderSelectModule,
        NgbTooltipMfeModule,
        MonSwitchModule,
        IconsModule,
        NgbTimepicker,
        LayoutModule,
        FormBuilderDynamicModule,
        FormBuilderDynamicAcModule,
        MonEventTriggerModule,
        FormBuilderSelectAcModule,
        MonActionMenuModule,
        ModalsDirectivesModule,
        NgbPagination,
        MonSelectAllCheckboxModule,
        UpgradeFormsModule,
        FormDomainDetailCmsComponent,
        FormBuilderValidationModule,
    ],
    declarations: [
        FormDomainComponent,
        FormDomainDetailComponent,
        FormDomainScanComponent,
        FormDomainFeaturesComponent,
        FormDomainUsersComponent,
        FormDomainGroupsComponent,
        FormDomainScanLoginFormComponent,
        FormDomainScanLoginOffice365Component,
        FormDomainScanLoginBasicAuthComponent,
        FormDomainScanLoginCustomMultistepComponent,
        FormDomainScanInternalUrlsComponent,
        FormDomainGroupsCreateComponent,
        FormDomainGroupsUsersComponent,
        FormDomainGroupsMatchRuleComponent,
        FormDomainGroupsRulesComponent,
        FormRulesImportSetupComponent,
        FormRuleImportUploadComponent,
        FormImportGroupRulesComponent,
        FormDomainGroupsEditComponent,
    ],
    exports: [
        FormDomainComponent,
        FormDomainDetailComponent,
        FormDomainScanComponent,
        FormDomainFeaturesComponent,
        FormDomainUsersComponent,
        FormDomainGroupsComponent,
        FormDomainScanLoginFormComponent,
        FormDomainScanLoginOffice365Component,
        FormDomainScanLoginBasicAuthComponent,
        FormDomainScanLoginCustomMultistepComponent,
        FormDomainScanInternalUrlsComponent,
        FormDomainGroupsCreateComponent,
        FormDomainGroupsUsersComponent,
        FormDomainGroupsMatchRuleComponent,
        FormDomainGroupsRulesComponent,
        FormRulesImportSetupComponent,
        FormRuleImportUploadComponent,
        FormImportGroupRulesComponent,
        FormDomainGroupsEditComponent,
    ],
})
export class DomainFormModule {}
